import { serializeWithSort } from '../../../../js/common/support/utils';
import { DomainAnalyticsService } from '../../../main/services/analytics/DomainAnalyticsService';
import type { QueryHashPayload } from '../../components/core/DruidQuery/types';
import { DruidQueryFilterService } from './DruidQueryFilterService';

export class DruidQueryHashService {
  static build(): DruidQueryHashService {
    return new DruidQueryHashService();
  }

  domainAnalyticsService: DomainAnalyticsService;

  filterService: DruidQueryFilterService;

  constructor() {
    this.domainAnalyticsService = DomainAnalyticsService.build();
    this.filterService = new DruidQueryFilterService();
  }

  private getIsReportQuery({ isReportQuery, reportQuery }: QueryHashPayload) {
    if (typeof isReportQuery === 'boolean') {
      return isReportQuery;
    }
    return reportQuery && this.domainAnalyticsService.isDomainAnalyticsAvailable(reportQuery);
  }

  private getIsTrendsQuery({ isTrendsQuery, trendsQuery }: QueryHashPayload) {
    if (typeof isTrendsQuery === 'boolean') {
      return isTrendsQuery;
    }
    return trendsQuery && this.domainAnalyticsService.isDomainAnalyticsAvailable(trendsQuery);
  }

  getHash(options: QueryHashPayload): string {
    const { query = {}, sourceQuery = {}, type, overrides, reportActiveMode } = options;

    const isReportQuery = this.getIsReportQuery(options);
    const isTrendsQuery = this.getIsTrendsQuery(options);
    const cleanedQuery = this.filterService.cleanEmptyFilters(query);

    const queryHashProps = { type, overrides, ...cleanedQuery, ...sourceQuery };
    if (isReportQuery) {
      queryHashProps.isReportQuery = true;
      queryHashProps.reportActiveMode = reportActiveMode;
    }
    if (isTrendsQuery) {
      queryHashProps.isTrendsQuery = true;
    }

    return serializeWithSort(queryHashProps);
  }
}
